import { Link } from "react-router-dom";
import {
  FaWhatsapp,
  FaMapMarkerAlt,
  FaEnvelope,
  FaHotel,
  FaCalendarCheck,
  FaSearch,
  FaHome,
  FaUserPlus,
  FaSignInAlt,
} from "react-icons/fa";

const WHATSAPP_NUMBER = "25779889844";
const EMAIL = "reception@alexestelhotel.com";
const ADDRESS = "Boulevard de l\u2019uprona Mikaza, Bujumbura, Burundi";

const FooterComponent = () => {
  return (
    <footer className="footer">
      <div className="footer__body">
        {/* Brand */}
        <div className="footer__brand">
          <p className="footer__brand-name">Alexestel Hotels</p>
          <p className="footer__brand-tagline">
            The Unforgettable Taste of Hospitality in Burundi
          </p>
          <p className="footer__brand-desc">
            Experience world-class comfort and warm hospitality at Alexestel
            Hotels. Whether you&apos;re here for business or leisure, we make
            every stay memorable.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <span className="footer__col-title">Quick Links</span>
          <ul className="footer__links">
            <li><Link to="/"><FaHome /> Home</Link></li>
            <li><Link to="/hotels"><FaHotel /> Book a Room</Link></li>
            <li><Link to="/find-booking"><FaCalendarCheck /> My Bookings</Link></li>
            <li><Link to="/find-booking"><FaSearch /> Find a Booking</Link></li>
            <li><Link to="/login"><FaSignInAlt /> Login</Link></li>
            <li><Link to="/register"><FaUserPlus /> Register</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <span className="footer__col-title">Contact Us</span>
          <ul className="footer__contact-list">
            <li className="footer__contact-item">
              <FaWhatsapp className="footer__contact-icon footer__whatsapp-icon" />
              <a
                href={`https://wa.me/${WHATSAPP_NUMBER}`}
                target="_blank"
                rel="noreferrer"
              >
                +257 79 889 844
              </a>
            </li>
            <li className="footer__contact-item">
              <FaEnvelope className="footer__contact-icon" />
              <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
            </li>
            <li className="footer__contact-item">
              <FaMapMarkerAlt className="footer__contact-icon" />
              <span>{ADDRESS}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer__bottom">
        Alexestel Hotels &mdash; All Rights Reserved &copy;{" "}
        {new Date().getFullYear()}
      </div>
    </footer>
  );
};

export default FooterComponent;
